export default __webpack_public_path__ + "static/media/certificado-digital-2.1edde363.png";